import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { ReactiveFormsModule } from "@angular/forms";
import { HttpClientModule, HttpClient } from "@angular/common/http";
import { TranslateModule } from '@ngx-translate/core';

import { LaddaModule } from "angular2-ladda";

import { LoginContainerComponent } from "./containers";
import { AuthService } from "src/app/domains/auth/services/auth.service";
import { LoginRoutingModule } from "./login-routing.module";
import { ValidationFailedComponent } from './components/validation-failed/validation-failed.component';

@NgModule({
  declarations: [LoginContainerComponent, ValidationFailedComponent],
  imports: [
    CommonModule,
    ReactiveFormsModule,
    HttpClientModule,
    TranslateModule.forChild(),
    LoginRoutingModule,
    LaddaModule.forRoot({
      style: "contract",
      spinnerSize: 40,
      spinnerColor: "grey",
      spinnerLines: 12
    })
  ],
  providers: [HttpClient, AuthService]
})
export class LoginModule {}
